module.exports = '<svg width="43" height="32" viewBox="0 0 43 32"><path d="M28.517 10.667c-1.389 0-2.08.635-1.787 1.491l.32.584.373.637 5.893 7.043c.107.16.187.291.293.397.744.803 1.731.669 2.373-.395l6.293-7.677c.883-1.152.216-2.08-1.493-2.08h-3.451v-8A2.664 2.664 0 0 0 34.664 0h-32A2.664 2.664 0 0 0-.003 2.667v26.667c0 1.467 1.2 2.667 2.667 2.667h32c1.475 0 2.667-1.192 2.667-2.667s-1.192-2.667-2.667-2.667H5.331V5.334h26.667v5.333h-3.483z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/repeat-2.js
// module id = 1369
// module chunks = 14